export default __webpack_public_path__ + "static/media/1.f5d2ffc0.png";